import { useLayoutEffect } from 'react'
import { redirectToWmsSignIn } from '../next/lib/wms-sign-in-url'

export default function () {
  useLayoutEffect(() => {
    redirectToWmsSignIn()
  }, [])
  return null
}
